module.exports = __webpack_public_path__ + "assets/images/family_g.15e07a4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/family_g.png
// module id = 708
// module chunks = 1